// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:03:08

export default {
  "id": "hook-master-mafia-city",
  "slug": "hook-master-mafia-city",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/2be9e4a6f9904542a68aa8941283a19e-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/2be9e4a6f9904542a68aa8941283a19e/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Hook Master Mafia City",
      "description": "Hook Master: Mafia City is a casual puzzle game that combines puzzle solving, escape and collecting elements. In this dangerous city, you have to solve puzzles with your smart mind and use a cool grappling hook and swing skills, like a secret agent's flexible dodge, precise strike\nand successfully escape the enemy hunt! There are two kinds of gameplay: grappling and swinging. Use the grapple for flexible movement, quickly across the city by snagging walls, buildings and so on. ",
      "instructions": "Mouse click or tap to play",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "combine",
        "escape",
        "fighting"
      ]
    },
    "zh-CN": {
      "title": "钩大师黑帮之城",
      "description": "钩大师：黑帮之城是一款休闲解谜游戏，融合了解谜、逃脱和收集元素。在这个危险的城市中，你必须用你的聪明才智解决谜题，并使用酷炫的钩爪和摇摆技巧，就像特工的灵活躲避、精准打击，成功逃脱敌人的追捕！游戏有两种玩法：钩爪和摇摆。使用钩爪进行灵活移动，通过钩住墙壁、建筑等快速穿越城市。",
      "instructions": "鼠标点击或轻触开始游戏",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "合成",
        "逃脱",
        "战斗"
      ]
    },
    "zh-TW": {
      "title": "釣魚大王黑幫城市",
      "description": "Hook Master: Mafia City 是一款結合了解謎、逃脫與收集元素的休闲解謎遊戲。在這個危險的城市中，你必須運用你的智慧解開謎題，並使用酷炫的鋸齒線索與懸吊技巧，如同秘密特務的靈活躲避、準確擊敵，成功逃離敵人的追捕！遊戲有兩種遊戲模式：鋸齒線索與懸吊。使用鋸齒線索進行靈活移動，快速穿越城市，抓住牆壁、建築物等。",
      "instructions": "鼠标點擊或滑動以開始遊戲",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "合體",
        "逃離",
        "戰鬥"
      ]
    },
    "zh-HK": {
      "title": "勾魂大師黑道城市",
      "description": "Hook Master: 黑幫之城是一款結合謎題解決、逃離和收集元素的輕鬆益智遊戲。在這個危險的城市中，你需要運用智慧解謎，並使用靈巧的鋸齒線和揮擊技巧，如間諜般靈活的迴避、準確的攻擊，成功脫離敵人追捕！遊戲有兩種玩法：鋸齒線和揮擊。使用鋸齒線進行靈活的移動，快速穿越城市，通過勾住牆壁、建築物等。",
      "instructions": "滑鼠點擊或觸控開始遊戲",
      "genres": [
        "輕鬆",
        "謎題"
      ],
      "tags": [
        "合體",
        "逃離",
        "戰鬥"
      ]
    },
    "ja": {
      "title": "フックマスター マフィアシティ",
      "description": "フックマスター：マフィアシティは、パズル解決、脱出、収集要素を組み合わせたカジュアルパズルゲームです。この危険な街で、あなたは賢い頭を使ってパズルを解決し、クールなグレイプホークとスイングスキルを用いて、スパイの柔軟な回避、正確な攻撃を駆使して敵の追手から逃げることができます。プレイスタイルは2種類あります：グレイプとスイング。グレイプを使って柔軟な動きをし、壁、ビルなどに絡みついて街を素早く横断します。",
      "instructions": "マウスクリックまたはタップして遊ぶ",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "コンバイン",
        "脱出",
        "戦闘"
      ]
    },
    "ko": {
      "title": "호크 마스터 마피아 시티",
      "description": "휩이는 마스터: 마피아 시티는 패자이스트 패uzzle 게임으로, 패uzzle 풀링, 탈출 및 수집 요소를 결합한 게임입니다. 이 위험한 도시에서는 지혜롭은 생각으로 패uzzle를 풀고, 시크한 그래핑 힙과 스윙 기술을 사용하여 비밀 요인처럼 유연한 도피, 정확한 히트와 적의 추격을 성공적으로 피해야 합니다! 두 가지 종류의 게임 플레이가 있습니다: 그래핑과 스윙. 그래핑을 사용하여 유연한 이동을 하고, 벽, 건물 등을 잡아 도시를 빠르게 통과하세요.",
      "instructions": "마우스 클릭이나 탭하여 게임 시작",
      "genres": [
        "캐주얼",
        "퍼즐"
      ],
      "tags": [
        "빈합성",
        "탈출",
        "전투"
      ]
    },
    "fr": {
      "title": "Maître du Hameçon Mafia City",
      "description": "Hook Master: Mafia City est un jeu de puzzle casual qui combine résolution de puzzles, évasion et éléments de collection. Dans cette ville dangereuse, vous devez résoudre des puzzles avec votre esprit vif et utiliser une grue de pêche et des compétences de swing, comme un évasion flexible d'agent secret, des coups précis et réussir à échapper à la chasse ennemie ! Il existe deux types de jeu : grapple et swing. Utilisez la grue pour un déplacement flexible, traversez rapidement la ville en saisissant des murs, des bâtiments et autres.",
      "instructions": "Clic ou tapotez pour jouer",
      "genres": [
        "Facile",
        "Puzzle"
      ],
      "tags": [
        "combiner",
        "s'échapper",
        "combattre"
      ]
    }
  }
};
